// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CvPaS","name":"styles_name__1tKQ1","phone":"styles_phone__2nwfW"};